const BROCHURE_URL = "/folleto-mariachi-mexicanisimo.pdf";

// Ícono de documento PDF (en vez del genérico de "descargar"), para que se
// reconozca de inmediato igual que el logo de WhatsApp identifica ese botón.
const PdfIcon = ({ className = "h-4 w-4" }) => (
    <svg viewBox="0 0 24 28" className={className} aria-hidden="true">
        <path
            d="M4 1.5h9.5L20 8v17a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 25V3a1.5 1.5 0 0 1 0-1.5Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
        />
        <path
            d="M13.5 1.5V7a1 1 0 0 0 1 1H20"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
        />
        <rect x="2.5" y="16" width="16" height="7.5" rx="1.4" fill="currentColor" />
        <text
            x="10.5"
            y="21.7"
            textAnchor="middle"
            fontSize="6"
            fontWeight="800"
            fill="white"
            fontFamily="Arial, sans-serif"
        >
            PDF
        </text>
    </svg>
);

/**
 * Botón flotante circular, justo encima del de WhatsApp (mismo tamaño y
 * estilo — solo ícono, sin texto), para descargar/ver el folleto en PDF
 * con fotos y paquetes del mariachi.
 */
export const FloatingBrochure = () => {
    return (
        <a
            href={BROCHURE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-brochure-btn"
            aria-label="Ver folleto en PDF"
            className="group fixed bottom-[104px] right-6 z-[59] inline-flex h-14 w-14 items-center justify-center rounded-full border-2 border-gold bg-background text-gold shadow-[0_10px_40px_rgba(212,175,55,0.35)] transition hover:scale-110 hover:bg-gold hover:text-black sm:right-7 sm:h-16 sm:w-16"
        >
            <PdfIcon className="h-6 w-6 sm:h-7 sm:w-7" />
            <span className="absolute right-full mr-3 hidden rounded-lg bg-black px-3 py-2 text-xs font-semibold text-white shadow-lg group-hover:block whitespace-nowrap">
                Ver folleto en PDF
                <span className="absolute right-[-4px] top-1/2 -translate-y-1/2 h-2 w-2 rotate-45 bg-black" />
            </span>
        </a>
    );
};

export default FloatingBrochure;
